export default __webpack_public_path__ + "static/media/g.5351f634.wav";